import { Skeleton } from 'ui/components/primitives';

import { PRODUCT_COMPACT_CONST } from './ProductCompact.d';
import { SkeletonProductCompact } from './ProductCompact.styles';

const ProductCompactSkeleton = () => (
  <SkeletonProductCompact.Component data-testid={PRODUCT_COMPACT_CONST.TEST_ID}>
    <SkeletonProductCompact.Picture>
      <Skeleton />
    </SkeletonProductCompact.Picture>

    <SkeletonProductCompact.InfoComponent>
      <SkeletonProductCompact.Code>
        <Skeleton />
      </SkeletonProductCompact.Code>
      <SkeletonProductCompact.Title>
        <Skeleton />
      </SkeletonProductCompact.Title>
    </SkeletonProductCompact.InfoComponent>

    <SkeletonProductCompact.PriceComponent>
      <SkeletonProductCompact.PriceTitle>
        <Skeleton />
      </SkeletonProductCompact.PriceTitle>
      <SkeletonProductCompact.Price>
        <Skeleton />
      </SkeletonProductCompact.Price>
    </SkeletonProductCompact.PriceComponent>

    <SkeletonProductCompact.ButtonAdd>
      <Skeleton />
    </SkeletonProductCompact.ButtonAdd>
  </SkeletonProductCompact.Component>
);

export default ProductCompactSkeleton;
